'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "render", "style"];
import * as React from 'react';
import { useRenderElement } from '@mui/x-scheduler-internals/base-ui-copy';
export const TimelineGridRow = /*#__PURE__*/React.forwardRef(function TimelineGridRow(componentProps, forwardedRef) {
  const elementProps = _objectWithoutPropertiesLoose(componentProps, _excluded);
  return useRenderElement('div', componentProps, {
    ref: [forwardedRef],
    props: [elementProps, {
      role: 'row'
    }]
  });
});
if (process.env.NODE_ENV !== "production") TimelineGridRow.displayName = "TimelineGridRow";